import { PERMISSIONS } from "../../../api/permissions";

export const MEDIA_FIELDS = [
  { key: "name", label: "name" },

  {
    key: "type",
    label: "Type",
    type: "fixed-select",
    options: [
      { label: "Company", value: "company" },
      { label: "Employee", value: "employee" },
    ],
  },
  
  {
    key: "amount_type",
    label: "Amount Type",
    type: "fixed-select",
    options: [
      { label: "Percentage", value: "percentage" },
      { label: "Constant", value: "constant" },
    ],
  },
  
  { key: "amount", label: "Amount" },
  
  {
    key: "isFinanceFees",
    label: "Is Finance Fees",
    type: "checkbox",
    hideField: () => {
      const permissions = localStorage.getItem("permissions")
        ? JSON.parse(localStorage.getItem("permissions"))
        : [];
      return !permissions.includes(PERMISSIONS.FINANCE_FEES_CHECKBOX);
    },
  },
  
  { key: "isVat", label: "Is Vat", type: "checkbox" },
  
  { key: "isPeriodically", label: "Periodically", type: "checkbox" },
  
  {
    key: "period",
    label: "Period (days)",
    type: "number",
    hideField: (validation) => !validation.values.isPeriodically,
  },
];

const FIELDS = [...MEDIA_FIELDS];

export default FIELDS;
